<template>
  <v-stepper
    v-model="currentStepIndex"
    class="elevation-0"
  >
    <!-- Progressbar -->
    <v-progress-linear
      v-if="showProgressbar"
      :value="progressValue"
      color="msr"
      height="8"
      class="mt-0"
    />
    <!-- Steps -->
    <v-stepper-items>
      <v-stepper-content
        v-for="(step, loopStepIndex) in steps"
        :key="'step-content-' + loopStepIndex"
        :step="loopStepIndex + 1"
        :class="{
          'px-5 py-4': $vuetify.breakpoint.smAndUp,
          'px-4 py-3': $vuetify.breakpoint.xs,
        }"
      >
        <v-card flat>
          <v-layout
            :column="useMobileLayout"
            align-center
            justify-space-between
          >
            <!-- Content -->
            <v-layout
              align-center
              wrap
            >
              <v-flex
                xs12
                sm6
              >
                <v-img
                  :src="step.image"
                  contain
                  :class="{
                    'mb-5': $vuetify.breakpoint.xs,
                    'mr-4': $vuetify.breakpoint.smAndUp,
                  }"
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <div
                  class="step--text unselectable"
                  :class="{
                    'text-xs-center': $vuetify.breakpoint.xs,
                    'ml-4': $vuetify.breakpoint.smAndUp,
                  }"
                >
                  {{ $t(step.text) }}
                </div>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout
            v-if="anyButtonVisible"
            justify-center
            :class="{
              'mt-4': $vuetify.breakpoint.xs,
              'mt-3': $vuetify.breakpoint.smAndUp,
            }"
          >
            <!-- Button backward -->
            <v-btn
              v-if="backButtonVisible"
              flat
              round
              large
              class="step-button backward"
              :class="{desktop: !useMobileLayout}"
              :disabled="!showBackButton || currentStepIndex == 1"
              :title="$t('goBack')"
              @click="currentStepIndex -= 1"
            >
              <v-icon
                large
                style="transform: rotate(-90deg); font-size: 56px"
                color="msr"
              >
                straight
              </v-icon>
            </v-btn>
            <!-- Button forward -->
            <v-btn
              v-if="forwardButtonVisible"
              flat
              round
              large
              class="step-button forward"
              :class="{desktop: !useMobileLayout}"
              :disabled="currentStepIndex >= steps.length"
              :title="$t('goForward')"
              data-cy="menu-how-to-stepper-next-btn"
              @click="currentStepIndex += 1"
            >
              <v-icon
                color="msr"
                style="transform: rotate(90deg); font-size: 56px"
              >
                straight
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
const MENU_START_WIZARD_IMAGE_URL_00 =
  'https://cms.myshopradio.de/filer/canonical/1713534806/1165/';
const MENU_START_WIZARD_IMAGE_URL_01 =
  'https://cms.myshopradio.de/filer/canonical/1713268247/1160/';
const MENU_START_WIZARD_IMAGE_URL_02 =
  'https://cms.myshopradio.de/filer/canonical/1713268247/1159/';
const MENU_START_WIZARD_IMAGE_URL_03 =
  'https://cms.myshopradio.de/filer/canonical/1713268243/1157/';
const MENU_START_WIZARD_IMAGE_URL_04 =
  'https://cms.myshopradio.de/filer/canonical/1713268243/1158/';
const MENU_START_WIZARD_IMAGE_URL_05 =
  'https://cms.myshopradio.de/filer/canonical/1713268243/1156/';
const MENU_START_WIZARD_IMAGE_URL_06 =
  'https://cms.myshopradio.de/filer/canonical/1713268247/1161/';

// Note: The 'text' values are translation keys and need a $t(...) call in the template.
export const HOW_TO_STEPS = [
  {
    image: MENU_START_WIZARD_IMAGE_URL_00,
    text: 'menuHowToStepperStep_00',
  },
  {
    image: MENU_START_WIZARD_IMAGE_URL_01,
    text: 'menuHowToStepperStep_01',
  },
  {
    image: MENU_START_WIZARD_IMAGE_URL_02,
    text: 'menuHowToStepperStep_02',
  },
  {
    image: MENU_START_WIZARD_IMAGE_URL_03,
    text: 'menuHowToStepperStep_03',
  },
  {
    image: MENU_START_WIZARD_IMAGE_URL_04,
    text: 'menuHowToStepperStep_04',
  },
  {
    image: MENU_START_WIZARD_IMAGE_URL_05,
    text: 'menuHowToStepperStep_05',
  },
  {
    image: MENU_START_WIZARD_IMAGE_URL_06,
    text: 'menuHowToStepperStep_06',
  },
];

export default {
  props: {
    stepIndex: {
      type: Number,
      required: true,
    },
    showInitialStep: {
      type: Boolean,
      default: false,
    },
    showProgressbar: {
      type: Boolean,
      default: true,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backButtonVisible() {
      return this.showBackButton && this.currentStepIndex > 1;
    },
    forwardButtonVisible() {
      return this.currentStepIndex < this.steps.length;
    },
    anyButtonVisible() {
      return this.backButtonVisible || this.forwardButtonVisible;
    },
    useMobileLayout() {
      return this.$vuetify.breakpoint.xs;
    },
    steps() {
      if (this.showInitialStep) {
        return HOW_TO_STEPS;
      }
      return HOW_TO_STEPS.slice(1);
    },
    currentStepIndex: {
      get() {
        return this.stepIndex;
      },
      set(value) {
        this.$emit('update:stepIndex', value);
      },
    },
    progressValue() {
      return (this.currentStepIndex - 1) * (100.0 / (this.steps.length - 1));
    },
  },
};
</script>

<style scoped>
.step {
  display: flex;
  flex-flow: row nowrap;
}

.step-button {
  z-index: 1;
}
.step-button:hover {
  background: rgba(0, 0, 0, 0.08);
}

.step-button.backward.desktop {
}

.step-button.forward.desktop {
}

.step--circle {
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
}

.step--text {
  display: flex;
  align-items: flex-start;
  font-size: 1.33rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuHowToStepper.vue